import { IConfig } from '@cian/config/shared';
import { INFRASTRUCTURE_RADIUS } from 'shared/constants/infrastructure';

type TInfrastructureProfile = 'suburban' | 'flat' | 'newobject' | 'commercial' | 'house';

export const getInfrastructureRadius = (config: IConfig): number => {
  const radiusMap = config.get<Record<TInfrastructureProfile, number>>('audience.infrastructureRadiusMap');

  return radiusMap?.house ?? INFRASTRUCTURE_RADIUS;
};
